import React from 'react';
var useEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
export default useEffect;